import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
// Game typography, self-hosted so the client depends on nothing external:
// Lilita One for display, Nunito for body, JetBrains Mono for figures.
import "@fontsource/lilita-one";
import "@fontsource/nunito/400.css";
import "@fontsource/nunito/600.css";
import "@fontsource/nunito/700.css";
import "@fontsource/nunito/800.css";
import "@fontsource/jetbrains-mono/400.css";
import "@fontsource/jetbrains-mono/700.css";
import "./styles.css";

const root = document.getElementById("root");
if (!root) throw new Error("#root is missing from index.html");

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
